/* ============================================================
   CONFIGURATOR DEBUG  (configurator-debug.js)

   Standalone, opt-in admin debug overlay for all LEVA
   configurators and related sections.

   Activation:
     window.__CFG_DEBUG = true;   (set inline from Liquid via admin gate)
     // ... then this script loads, mounts button + panel
   Or runtime:
     Configurator.debug.enable() / disable()

   When disabled: NO DOM is created, NO console patched.
   No flicker, no leak. Pure no-op for non-admin visitors.

   API:
     Configurator.debug.push(label, data)
       Push an event into the rolling log (last 40 entries).
     Configurator.debug.registerSection(title, fn, opts?)
       Module registers a panel section. fn() returns a string
       (rendered as <pre>) or { text, html, async }.
     Configurator.debug.registerStatus(label, checkFn, detailFn?)
       Quick ✓/✗ row in the top STATUS block.
     Configurator.debug.registerAction(label, fn)
       Adds a button to the panel header.
     Configurator.debug.refresh()
       Force a re-render of all sections.
     Configurator.debug.enable() / disable()
       Runtime toggle (creates / destroys panel).
     Configurator.debug.lines()
       Every line pushed since the page opened (admin only),
       { lines, cut } -- cut is how many of the oldest were dropped.
     Configurator.debug.hush(fn)
       Runs fn without keeping its lines (a snapshot echoes
       itself into the log; that echo is not kept).
     Configurator.debug.send({ kind, product, version, text }, cb)
       POSTs the text to leva-share /log. cb({ ok, id, status }).
     Configurator.debug.sendButton(btn, kind, getText, meta)
       Wires a SEND LOG / SEND RAW button: SENT #N on success,
       FAIL <status> and the text copied to the clipboard otherwise.

   Aliases (back-compat with budget-sharing.liquid):
     window.__LEVA_DEBUG_PUSH(label, data)        →  Configurator.debug.push
     window.__LEVA_DEBUG_LOG                      →  array view, mutates with push
     window.__LEVA_DEBUG_LAST_RENDERED_LIST       →  passthrough (kept as-is)
     window.__LEVA_DEBUG_ENABLED                  →  reads __CFG_DEBUG

   Styling and layout mirror the LEVA debug overlay
   (top-right, light, accordion sections).
   ============================================================ */

(function (global) {
  'use strict';

  if (global.Configurator && global.Configurator.debug && global.Configurator.debug.__sealed) {
    console.warn('[configurator-debug] already loaded; ignoring duplicate include');
    return;
  }

  /* ----------------------------------------------------------
     STATE
     ---------------------------------------------------------- */
  var enabled = (global.__CFG_DEBUG === true) ||
                (global.__LEVA_DEBUG_ENABLED === true);

  var sections   = [];   // [{ title, fn, opts }]
  var statuses   = [];   // [{ label, check, detail }]
  var actions    = [];   // [{ label, fn }]
  var logBuffer  = [];   // rolling event log (last 40)
  var MAX_LOG    = 40;

  /* EVERY LINE, NOT THE LAST FORTY (debug-v2, Marek: SEND RAW posle cely
     log bez filtru FOCUS, vsechny radky). The panel keeps forty entries and
     the snapshot keeps what the last build said; the lines in between --
     the plan reader, the command bar, the page being left and coming back --
     were kept nowhere. For the admin they are kept here from the first one,
     up to the size a send can carry; the oldest go first. A visitor keeps
     nothing. */
  var VERSION    = 'debug-v3-nobug';
  var LOG_URL    = 'https://leva-share.long-cloud-d006.workers.dev/log';
  var SEND_MAX   = 1500000;  // characters per send, the endpoint's own limit
  var ALL_MAX    = 1500000;  // characters kept in allLines
  var LINE_MAX   = 100000;   // one line longer than this is cut
  var allLines   = [];
  var allChars   = 0;
  var allCut     = 0;
  var hushed     = 0;

  // DOM refs (created lazily when enabled)
  var btnEl      = null;
  var panelEl    = null;
  var bodyEl     = null;
  var headerEl   = null;
  var refreshIv  = null;

  /* ----------------------------------------------------------
     UTILITY
     ---------------------------------------------------------- */
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function stringifyData(d) {
    if (d == null) return '';
    if (typeof d === 'string') return d;
    try { return JSON.stringify(d, null, 2); }
    catch (e) { return String(d); }
  }

  function secs() {
    try {
      if (global.performance && global.performance.now) return (global.performance.now() / 1000).toFixed(1);
    } catch (e) {}
    return '?';
  }

  function keepLine(label, data) {
    if (!enabled || hushed) return;
    try {
      var s = (label === 'log') ? '' : String(label);
      if (data != null) {
        var d = (typeof data === 'string') ? data : (function () { try { return JSON.stringify(data); } catch (e) { return String(data); } })();
        s += (s ? ' ' : '') + d;
      }
      var line = '+' + secs() + 's ' + s;
      if (line.length > LINE_MAX) line = line.slice(0, LINE_MAX) + ' ...[cut, ' + line.length + ' characters in all]';
      allLines.push(line);
      allChars += line.length + 1;
      while (allChars > ALL_MAX && allLines.length > 1) { allChars -= allLines.shift().length + 1; allCut++; }
    } catch (e) {}
  }

  /* ----------------------------------------------------------
     STYLES  (injected once when first enabled)
     ---------------------------------------------------------- */
  var STYLE_ID = 'cfg-debug-style';
  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css = ''
      + '#cfg-debug-toggle{position:fixed;bottom:12px;left:12px;z-index:99998;'
      + 'width:44px;height:44px;border-radius:50%;border:1px solid rgba(0,0,0,.15);'
      + 'background:#fff;box-shadow:0 2px 8px rgba(0,0,0,.18);font-size:22px;'
      + 'line-height:1;cursor:pointer;display:flex;align-items:center;'
      + 'justify-content:center;padding:0;}'
      + '#cfg-debug-panel{position:fixed;top:12px;left:12px;bottom:12px;'
      + 'width:min(440px,calc(100vw - 24px));z-index:99999;background:#fff;'
      + 'border:1px solid rgba(0,0,0,.18);border-radius:10px;'
      + 'box-shadow:0 8px 32px rgba(0,0,0,.25);display:flex;flex-direction:column;'
      + 'font-family:-apple-system,BlinkMacSystemFont,sans-serif;color:#1c1c1e;}'
      + '#cfg-debug-panel[hidden]{display:none;}'
      + '#cfg-debug-panel header{display:flex;align-items:center;'
      + 'justify-content:space-between;padding:8px 10px;border-bottom:1px solid #eee;'
      + 'background:#fafafa;border-radius:10px 10px 0 0;}'
      + '#cfg-debug-panel header .cfg-debug-title{font-weight:700;font-size:13px;}'
      + '#cfg-debug-panel header .cfg-debug-actions{display:flex;gap:4px;flex-wrap:wrap;}'
      + '#cfg-debug-panel header button{border:1px solid #ddd;background:#fff;'
      + 'padding:4px 10px;border-radius:6px;font-size:12px;cursor:pointer;line-height:1;}'
      + '#cfg-debug-panel header button:hover{background:#f0f0f0;}'
      + '.cfg-debug-body{flex:1;overflow-y:auto;padding:8px 10px;font-size:11px;line-height:1.4;}'
      + '.cfg-debug-body details{border:1px solid #eee;border-radius:6px;'
      + 'margin-bottom:6px;background:#fff;}'
      + '.cfg-debug-body summary{padding:6px 8px;cursor:pointer;font-weight:600;'
      + 'font-size:12px;background:#f5f5f7;border-radius:6px;user-select:none;}'
      + '.cfg-debug-body details[open] summary{border-radius:6px 6px 0 0;}'
      + '.cfg-debug-body pre{margin:0;padding:8px;font-family:ui-monospace,'
      + 'SFMono-Regular,Menlo,monospace;font-size:11px;white-space:pre-wrap;'
      + 'word-break:break-all;background:#fff;border-radius:0 0 6px 6px;color:#2c2c2e;}'
      + '.cfg-debug-status-row{display:flex;justify-content:space-between;'
      + 'padding:3px 8px;font-size:11px;font-family:ui-monospace,SFMono-Regular,Menlo,monospace;}'
      + '.cfg-debug-status-row .ok{color:#1a7f37;}'
      + '.cfg-debug-status-row .fail{color:#b42318;}'
      + '.cfg-debug-status-row .detail{color:#666;margin-left:6px;font-weight:normal;}'
      + '.cfg-debug-log-entry{padding:4px 8px;border-bottom:1px solid #f0f0f0;'
      + 'font-family:ui-monospace,SFMono-Regular,Menlo,monospace;}'
      + '.cfg-debug-log-entry .ts{color:#888;font-size:10px;}'
      + '.cfg-debug-log-entry .label{font-weight:600;}'
      + '.cfg-debug-log-entry pre{padding:2px 0;margin:2px 0 0;background:transparent;border:0;}';
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent = css;
    document.head.appendChild(st);
  }

  /* ----------------------------------------------------------
     RENDER
     ---------------------------------------------------------- */
  function renderStatusSection() {
    if (!statuses.length) {
      return '<details open><summary>Status (0)</summary>' +
             '<pre>(no status providers registered yet — registration race?)</pre>' +
             '</details>';
    }
    var rows = statuses.map(function (s) {
      var ok = false, detail = '';
      try { ok = !!s.check(); } catch (e) { ok = false; }
      if (ok && s.detail) {
        try { detail = s.detail() || ''; } catch (e) {}
      }
      return '<div class="cfg-debug-status-row">' +
        '<span>' + escapeHtml(s.label) + '</span>' +
        '<span class="' + (ok ? 'ok' : 'fail') + '">' +
          (ok ? '✓' : '✗') +
          (detail ? '<span class="detail">' + escapeHtml(detail) + '</span>' : '') +
        '</span>' +
      '</div>';
    }).join('');
    return '<details open><summary>Status (' + statuses.length + ')</summary>' +
           '<div>' + rows + '</div></details>';
  }

  function renderLogSection() {
    if (!logBuffer.length) {
      return '<details open><summary>Event log (0)</summary>' +
             '<pre>(no events pushed yet)</pre></details>';
    }
    var entries = logBuffer.map(function (e) {
      var ts = e.ts.split('T')[1] ? e.ts.split('T')[1].slice(0, 8) : e.ts;
      var dataStr = e.data == null ? '' : stringifyData(e.data);
      return '<div class="cfg-debug-log-entry">' +
        '<span class="ts">[' + escapeHtml(ts) + ']</span> ' +
        '<span class="label">' + escapeHtml(e.label) + '</span>' +
        (dataStr ? '<pre>' + escapeHtml(dataStr) + '</pre>' : '') +
      '</div>';
    }).join('');
    return '<details open><summary>Event log (' + logBuffer.length + ')</summary>' +
           '<div>' + entries + '</div></details>';
  }

  function renderModuleSections() {
    return sections.map(function (s, i) {
      var content = '';
      var isAsync = false;
      try {
        var r = s.fn();
        if (r && typeof r === 'object' && !Array.isArray(r)) {
          if (r.async) {
            isAsync = true;
            content = '(loading…)';
          } else if (typeof r.html === 'string') {
            content = r.html;
          } else if (typeof r.text === 'string') {
            content = escapeHtml(r.text);
          } else {
            content = escapeHtml(stringifyData(r));
          }
        } else {
          content = escapeHtml(String(r == null ? '' : r));
        }
      } catch (e) {
        content = '<span style="color:#b42318;">ERROR: ' +
                  escapeHtml(e && e.message || String(e)) + '</span>';
      }
      var openAttr = (s.opts && s.opts.collapsed) ? '' : ' open';
      return '<details' + openAttr + ' data-cfg-section="' + i + '">' +
        '<summary>' + escapeHtml(s.title) + '</summary>' +
        '<pre data-cfg-section-pre="' + i + '">' + content + '</pre>' +
      '</details>';
    }).join('');
  }

  function resolveAsyncSections() {
    sections.forEach(function (s, i) {
      var r;
      try { r = s.fn(); } catch (e) { return; }
      if (!r || !r.async || typeof r.promise !== 'object') return;
      var pre = bodyEl && bodyEl.querySelector('pre[data-cfg-section-pre="' + i + '"]');
      if (!pre) return;
      r.promise.then(function (val) {
        if (val && typeof val === 'object' && typeof val.html === 'string') {
          pre.innerHTML = val.html;
        } else {
          pre.textContent = stringifyData(val);
        }
      }).catch(function (err) {
        pre.innerHTML = '<span style="color:#b42318;">ERROR: ' +
                        escapeHtml(err && err.message || String(err)) + '</span>';
      });
    });
  }

  function renderAll() {
    if (!bodyEl) return;
    bodyEl.innerHTML =
      renderStatusSection() +
      renderModuleSections() +
      renderLogSection();
    resolveAsyncSections();
  }

  function renderHeaderActions() {
    if (!headerEl) return;
    var actionsEl = headerEl.querySelector('.cfg-debug-actions');
    if (!actionsEl) return;
    actionsEl.innerHTML = actions.map(function (a, i) {
      return '<button type="button" data-cfg-debug-action="' + i + '">' +
             escapeHtml(a.label) + '</button>';
    }).join('') +
      '<button type="button" data-cfg-debug-builtin="copy" title="Copy panel contents to clipboard">📋 Copy</button>' +
      '<button type="button" data-cfg-debug-builtin="refresh">↻</button>' +
      '<button type="button" data-cfg-debug-builtin="close">×</button>';
  }

  /* ----------------------------------------------------------
     MOUNT / UNMOUNT
     ---------------------------------------------------------- */
  function mount() {
    if (btnEl) return;
    injectStyle();

    btnEl = document.createElement('button');
    btnEl.id = 'cfg-debug-toggle';
    btnEl.type = 'button';
    btnEl.textContent = '🐛';
    btnEl.title = 'Configurator debug';
    /* THE ROUND BUG BUTTON IS GONE (debug-v3, Marek: dole je kulate tlacitko
       bug, nalevo -- take pryc). SEND LOG and SEND RAW carry everything it
       showed; the lines are still kept here for them. The button is made
       and kept off the page, so nothing that asks for it breaks. */
    btnEl.style.display = 'none';
    document.body.appendChild(btnEl);

    panelEl = document.createElement('div');
    panelEl.id = 'cfg-debug-panel';
    panelEl.hidden = true;
    panelEl.innerHTML =
      '<header>' +
        '<span class="cfg-debug-title">Configurator debug</span>' +
        '<div class="cfg-debug-actions"></div>' +
      '</header>' +
      '<div class="cfg-debug-body"></div>';
    document.body.appendChild(panelEl);

    headerEl = panelEl.querySelector('header');
    bodyEl   = panelEl.querySelector('.cfg-debug-body');

    renderHeaderActions();

    btnEl.addEventListener('click', function () {
      panelEl.hidden = !panelEl.hidden;
      if (!panelEl.hidden) {
        renderAll();
        clearInterval(refreshIv);
        refreshIv = setInterval(renderAll, 2000);
      } else {
        clearInterval(refreshIv);
      }
    });

    panelEl.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.getAttribute) return;
      var builtin = t.getAttribute('data-cfg-debug-builtin');
      if (builtin === 'close') {
        panelEl.hidden = true;
        clearInterval(refreshIv);
        return;
      }
      if (builtin === 'refresh') {
        renderAll();
        return;
      }
      if (builtin === 'copy') {
        /* Build a plain-text version of the entire panel and copy it. */
        var lines = [];
        lines.push('=== Configurator debug snapshot ===');
        lines.push('URL: ' + (location.href || ''));
        lines.push('Time: ' + new Date().toISOString());
        lines.push('User agent: ' + (navigator.userAgent || ''));
        lines.push('');
        if (bodyEl) {
          /* Walk the rendered DOM and extract text faithfully. */
          var blocks = bodyEl.querySelectorAll('details, section, .cfg-debug-status, .cfg-debug-log, pre');
          if (blocks.length === 0) {
            lines.push(bodyEl.innerText || bodyEl.textContent || '');
          } else {
            blocks.forEach(function (b) {
              var txt = (b.innerText || b.textContent || '').replace(/\s+\n/g, '\n').trim();
              if (txt) { lines.push(txt); lines.push(''); }
            });
          }
        }
        var payload = lines.join('\n');
        var done = false;
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(payload).then(function () {
              t.textContent = '✓ Copied';
              setTimeout(function () { t.textContent = '📋 Copy'; }, 1500);
            }).catch(function () { fallbackCopy(); });
            done = true;
          }
        } catch (_) {}
        if (!done) fallbackCopy();
        function fallbackCopy() {
          /* Old-school textarea trick — works without secure context. */
          var ta = document.createElement('textarea');
          ta.value = payload;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          try {
            document.execCommand('copy');
            t.textContent = '✓ Copied';
            setTimeout(function () { t.textContent = '📋 Copy'; }, 1500);
          } catch (_) {
            t.textContent = '✗ Failed';
            setTimeout(function () { t.textContent = '📋 Copy'; }, 1500);
          }
          document.body.removeChild(ta);
        }
        return;
      }
      var actIdx = t.getAttribute('data-cfg-debug-action');
      if (actIdx != null) {
        var a = actions[Number(actIdx)];
        if (a && typeof a.fn === 'function') {
          try { a.fn(); } catch (err) {
            push('action error: ' + a.label, err && err.message || String(err));
          }
          setTimeout(renderAll, 300);
        }
      }
    });
  }

  function unmount() {
    clearInterval(refreshIv);
    refreshIv = null;
    if (btnEl && btnEl.parentNode)     btnEl.parentNode.removeChild(btnEl);
    if (panelEl && panelEl.parentNode) panelEl.parentNode.removeChild(panelEl);
    btnEl = panelEl = bodyEl = headerEl = null;
  }

  /* ----------------------------------------------------------
     API
     ---------------------------------------------------------- */
  function push(label, data) {
    keepLine(label, data);
    try {
      logBuffer.unshift({
        ts: new Date().toISOString(),
        label: String(label),
        data: data == null ? null : data
      });
      if (logBuffer.length > MAX_LOG) logBuffer.length = MAX_LOG;
      if (panelEl && !panelEl.hidden) renderAll();
    } catch (e) {}
  }

  function registerSection(title, fn, opts) {
    sections.push({ title: title, fn: fn, opts: opts || {} });
    if (panelEl && !panelEl.hidden) renderAll();
  }

  function registerStatus(label, checkFn, detailFn) {
    statuses.push({ label: label, check: checkFn, detail: detailFn });
    if (panelEl && !panelEl.hidden) renderAll();
  }

  function registerAction(label, fn) {
    actions.push({ label: label, fn: fn });
    renderHeaderActions();
  }

  function enable() {
    enabled = true;
    global.__CFG_DEBUG = true;
    global.__LEVA_DEBUG_ENABLED = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mount);
    } else {
      mount();
    }
  }

  function disable() {
    enabled = false;
    global.__CFG_DEBUG = false;
    global.__LEVA_DEBUG_ENABLED = false;
    unmount();
  }

  function refresh() {
    if (panelEl && !panelEl.hidden) renderAll();
  }

  /* ----------------------------------------------------------
     SEND LOG / SEND RAW  (debug-v2)

     The log goes to leva-share /log and lands in D1, where
     Claude reads it -- no more copying into Word and a PDF.
     When the send fails the button says FAIL and the HTTP
     status, and the text goes to the clipboard instead, so
     nothing is lost.
     ---------------------------------------------------------- */
  function hush(fn) {
    hushed++;
    try { return fn(); } finally { hushed--; }
  }

  function lines() {
    return { lines: allLines.slice(), cut: allCut };
  }

  function clip(text, then) {
    function fallback() {
      var ok = false;
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
        document.body.appendChild(ta);
        ta.select();
        ok = !!document.execCommand('copy');
        document.body.removeChild(ta);
      } catch (e) { ok = false; }
      then(ok);
    }
    try {
      if (global.navigator && global.navigator.clipboard && global.navigator.clipboard.writeText) {
        global.navigator.clipboard.writeText(text).then(function () { then(true); }, fallback);
        return;
      }
    } catch (e) {}
    fallback();
  }

  function send(opts, cb) {
    opts = opts || {};
    var text = String(opts.text == null ? '' : opts.text);
    if (text.length > SEND_MAX) {
      var note = '\n... cut here: a send carries ' + SEND_MAX + ' characters, this text had ' + text.length;
      text = text.slice(0, SEND_MAX - note.length) + note;
    }
    var finished = false, timer = null, ctl = null;
    function end(r) {
      if (finished) return;
      finished = true;
      if (timer) clearTimeout(timer);
      r.text = text;
      try { cb(r); } catch (e) {}
    }
    if (typeof global.fetch !== 'function') { end({ ok: false, status: 'NO FETCH' }); return; }
    var body;
    try {
      body = JSON.stringify({
        kind: opts.kind === 'raw' ? 'raw' : 'log',
        product: String(opts.product || ''),
        version: String(opts.version || ''),
        page: String(global.location ? global.location.href : ''),
        text: text
      });
    } catch (eJ) { end({ ok: false, status: 'JSON', error: String((eJ && eJ.message) || eJ) }); return; }
    try { ctl = (typeof global.AbortController === 'function') ? new global.AbortController() : null; } catch (eA) { ctl = null; }
    timer = setTimeout(function () {
      try { if (ctl) ctl.abort(); } catch (eT) {}
      end({ ok: false, status: 'TIMEOUT' });
    }, 30000);
    var init = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, credentials: 'omit', cache: 'no-store' };
    if (ctl) init.signal = ctl.signal;
    global.fetch(LOG_URL, init).then(function (res) {
      return res.text().then(function (t) {
        var j = null;
        try { j = JSON.parse(t); } catch (eP) {}
        if (res.ok && j && j.ok === true) end({ ok: true, id: j.id, status: res.status });
        else end({ ok: false, status: res.status, error: (j && j.error) ? String(j.error) : String(t || '').slice(0, 200) });
      });
    }).catch(function (e) {
      end({ ok: false, status: 'NET', error: String((e && e.message) || e) });
    });
  }

  function sendButton(btn, kind, getText, meta) {
    if (!btn) return;
    kind = (kind === 'raw') ? 'raw' : 'log';
    var label = (kind === 'raw') ? 'SEND RAW' : 'SEND LOG';
    btn.textContent = label;
    btn.setAttribute('data-send', '');
    btn.addEventListener('click', function () {
      if (btn.getAttribute('data-send') === 'busy') return;
      btn.setAttribute('data-send', 'busy');
      btn.textContent = 'SENDING...';
      var text, m;
      try { text = String(getText(kind)); }
      catch (e) { text = label + ': building the text threw ' + ((e && e.message) || e); }
      try { m = (typeof meta === 'function') ? meta() : (meta || {}); } catch (eM) { m = {}; }
      send({ kind: kind, product: m.product, version: m.version, text: text }, function (r) {
        if (r.ok) {
          btn.setAttribute('data-send', 'ok');
          btn.textContent = 'SENT #' + (r.id != null ? r.id : '?');
          push('[configurator-debug] ' + label + ' sent as #' + r.id + ', ' + r.text.length + ' characters');
          return;
        }
        btn.setAttribute('data-send', 'fail');
        btn.textContent = 'FAIL ' + r.status;
        push('[configurator-debug] ' + label + ' failed: ' + r.status + (r.error ? (' ' + r.error) : '') + ' -- the text goes to the clipboard');
        clip(r.text, function (ok) {
          btn.textContent = 'FAIL ' + r.status + (ok ? ' / COPIED' : ' / NOT COPIED');
        });
      });
    });
  }

  /* ----------------------------------------------------------
     PUBLIC EXPORT
     ---------------------------------------------------------- */
  global.Configurator = global.Configurator || {};
  global.Configurator.debug = {
    push:             push,
    registerSection:  registerSection,
    registerStatus:   registerStatus,
    registerAction:   registerAction,
    enable:           enable,
    disable:          disable,
    refresh:          refresh,
    isEnabled:        function () { return enabled; },
    getLog:           function () { return logBuffer.slice(); },
    lines:            lines,
    hush:             hush,
    send:             send,
    sendButton:       sendButton,
    VERSION:          VERSION,
    __sealed:         true
  };

  /* ----------------------------------------------------------
     ALIASES  (back-compat for budget-sharing.liquid and older
     pool inline scripts)
     ---------------------------------------------------------- */
  global.__LEVA_DEBUG_PUSH = push;
  global.__LEVA_DEBUG_LOG = logBuffer;
  // __LEVA_DEBUG_ENABLED is read by older code; keep it in sync with our state.
  Object.defineProperty(global, '__LEVA_DEBUG_ENABLED_PROXY', {
    configurable: true,
    get: function () { return enabled; }
  });

  /* ----------------------------------------------------------
     BOOT
     ---------------------------------------------------------- */
  push('[configurator-debug] script executed, enabled=' + enabled);
  if (enabled) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){
        mount();
        push('[configurator-debug] panel mounted');
      });
    } else {
      mount();
      push('[configurator-debug] panel mounted');
    }
  }

})(window);